import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import uuid from 'uuid'
import { get } from 'lodash'
import { Table, Data } from 'components/layout/Table'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { TasksEvidence } from 'components/sections/tasks'
import { AssessorReport } from 'containers/sections/assessors'
import { Modal } from 'containers/misc'
import { Button, ButtonGroup, Status } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import config from 'config'

export default class TasksAjParticipantEventsTable extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    codeLists: PropTypes.object
  }

  static defaultProps = {
    list: []
  }

  state = {
    assessorPhotos: null,
    ajParticipantEventIdApprove: null,
    ajParticipantEventIdReturn: null,
    ajPeId: null,
    ajPeActionId: null,
    isAssessmentPositive: false,
    observations: null,
    fileUrls: []
  }

  key = uuid.v1()

  handleApproveParticipantEventModal = ajParticipantEventIdApprove => {
    this.setState(
      {
        ajParticipantEventIdApprove
      },
      () => {
        this.props.modal(`modal-approve-aj-participant-event-${this.key}`)
      }
    )
  }

  handleReturnParticipantEventModal = ajParticipantEventIdReturn => {
    this.setState(
      {
        ajParticipantEventIdReturn
      },
      () => {
        this.props.modal(`modal-return-aj-participant-event-${this.key}`)
      }
    )
  }

  handleShowEvidence = (observations, fileUrls) => {
    this.setState(
      {
        observations,
        fileUrls
      },
      () => {
        this.props.modal(`modal-show-evidence-${this.key}`)
      }
    )
  }

  handleShowAssessorNote = (ajPeId, ajPeActionId, isAssessmentPositive) => {
    this.setState(
      {
        ajPeId,
        ajPeActionId,
        isAssessmentPositive
      },
      () => {
        this.props.modal(`modal-show-assessor-note-${this.key}`)
      }
    )
  }

  render() {
    const { data, approveModal, returnModal, isAssessorManagementEnabled, codeLists } = this.props

    return (
      <div>
        <Table ths={tasksLayout.ajParticipantEventsSingle}>
          <Data>
            <tr>
              <td>
                {get(data, 'participantEvent.award.participant.firstName')}
              </td>
              <td>
                {get(data, 'participantEvent.award.participant.lastName')}
              </td>
              <td>
                <Link
                  className="link"
                  to={`${config.publicPath}/adventurous-journeys/${get(data, 'id')}/detail`}
                >
                  <FormattedMessage id="button.view" defaultMessage="View" />
                </Link>
              </td>
              <td>
                <Button
                  type="button"
                  intlKey="button.view"
                  link
                  onClick={() =>
                    this.handleShowEvidence(
                      get(data, 'participantEvent.observations'),
                      get(data, 'participantEvent.fileUrls')
                    )
                  }
                >
                  View
                </Button>
              </td>
              <td
                className={
                  !get(data, 'participantEvent.isAssessmentPositive')
                    ? 'text--center'
                    : ''
                }
              >
                {get(data, 'participantEvent.isAssessmentPositive') && (
                  <Button
                    type="button"
                    link
                    intlKey="button.view"
                    onClick={() =>
                      this.handleShowAssessorNote(
                        get(data, 'participantEvent.id'),
                        get(
                          data,
                          'participantEvent.ajParticipantEventAssessmentActionId'
                        ),
                        get(data, 'participantEvent.isAssessmentPositive')
                      )
                    }
                  >
                    View
                  </Button>
                )}
                <Status
                  state={get(data, 'participantEvent.isAssessmentPositive')}
                  check
                  inline
                  toRight
                />
              </td>
              <td>
                <ButtonGroup>
                  <Button
                    type="button"
                    tiny
                    onClick={() =>
                      this.handleApproveParticipantEventModal(
                        get(data, 'participantEvent.id')
                      )
                    }
                    intlKey="button.approve"
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    tiny
                    onClick={() =>
                      this.handleReturnParticipantEventModal(
                        get(data, 'participantEvent.id')
                      )
                    }
                    intlKey="button.revise"
                    secondary
                  >
                    Revise
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <Modal
          id={`modal-approve-aj-participant-event-${this.key}`}
          customActions
        >
          <TaskApprove
            id={this.state.ajParticipantEventIdApprove}
            approve={approveModal}
            modal={this.props.modal}
          />
        </Modal>
        <Modal
          id={`modal-return-aj-participant-event-${this.key}`}
          customActions
        >
          <TaskReturn
            returnTask={returnModal}
            id={this.state.ajParticipantEventIdReturn}
            modal={this.props.modal}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
          />
        </Modal>
        <Modal id={`modal-show-evidence-${this.key}`}>
          <TasksEvidence
            observations={this.state.observations}
            fileUrls={this.state.fileUrls}
          />
        </Modal>
        {this.state.ajPeId &&
          this.state.ajPeActionId &&
          this.state.isAssessmentPositive && (
            <Modal id={`modal-show-assessor-note-${this.key}`}>
              <AssessorReport
                id={this.state.ajPeId}
                actionId={this.state.ajPeActionId}
                assessed={this.state.isAssessmentPositive}
                isParticipantEvent
              />
            </Modal>
          )}
      </div>
    )
  }
}
